import { render, staticRenderFns } from "./ControlIndex.vue?vue&type=template&id=a62ba9e2&scoped=true"
import script from "./ControlIndex.vue?vue&type=script&lang=js"
export * from "./ControlIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62ba9e2",
  null
  
)

export default component.exports